<div class="connectivity-equipment">
  <div class="connectivity-equipment__add-btn">
    <button class="vox-btn vox-btn-secondary" [disabled]="company.readOnly" (click)="openAddEquipmentPopup()"
      translate>company.connectivity.details.equipment.add</button>
  </div>
  <div *ngIf="showErrorMsg" class="vox-inline-message vox-inline-message_light-grey">
    <div>
      <i class="icon-small-alert"></i>
      <span translate>company.connectivity.details.equipment.error</span>
    </div>
  </div>
  <div *ngIf="!showErrorMsg" class="vox-table">
    <table>
      <thead>
        <tr>
          <td translate>company.connectivity.details.equipment.table.thead.type</td>
          <td translate>company.connectivity.details.equipment.table.thead.mac-address-imei</td>
          <td translate>company.connectivity.details.equipment.table.thead.model</td>
          <td translate>company.connectivity.details.equipment.table.thead.actions</td>
        </tr>
      </thead>
      <tbody *ngIf="!loading">
        <ng-container *ngFor="let e of equipmentList">
          <tr class="user-data-row">
            <td>
              <gdp-connectivity-entry-type [type]="e.equipment_type">
              </gdp-connectivity-entry-type>
            </td>
            <td>
              <span *ngIf="e.mac_address">{{e.mac_address}}</span>
              <span *ngIf="e.imei">{{e.imei}}</span>
            </td>
            <td>{{e.model}}</td>
            <td class="user-data-row__actions">
              <div class="user-data-row__actions--wrapper">
                <button class="vox-btn btn btn-warning" [disabled]="company.readOnly"
                  (click)="openEquipmentInfoPopup(e)">
                  <i class="icon-small-info"></i>
                </button>
                <button class="vox-btn btn btn-warning" [disabled]="company.readOnly"
                  (click)="openEditEquipmentInfoPopup(e)">
                  <i class="icon-small-edit"></i>
                </button>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
      <tbody *ngIf="loading">
        <tr *ngFor="let i of [1,2,3,4]">
          <td colspan="3">
            <ngx-skeleton-loader [theme]="{'margin-bottom': 0}"></ngx-skeleton-loader>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="!loading && equipmentList.length === 0">
        <tr>
          <td colspan="3" translate>company.connectivity.details.equipment.table.empty</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>